// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../../shared/media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../../shared/core/domain/api-models/SharedApiModel.mjs";
import * as VehicleApiModelV2$PorterinFeature from "../../../../shared/vehicles/domain/api-model/VehicleApiModelV2.mjs";

function addition_service_pointer_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var icon = MediaApiModel$PorterinFeature.image_short_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon"), null));
      if (icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  sub_text: sub_text._0,
                  icon: icon._0
                }
              };
      }
      var e = icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function addition_service_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var pointers = Decco.arrayFromJson(addition_service_pointer_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pointers"), null));
      if (pointers.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  sub_text: sub_text._0,
                  pointers: pointers._0
                }
              };
      }
      var e = pointers._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".pointers" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function path_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var alternativeText = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alternativeText"), null));
    if (alternativeText.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  alternativeText: alternativeText._0,
                  name: name._0
                }
              };
      }
      var e = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = alternativeText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".alternativeText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function image_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt"), null));
  if (alt.TAG === /* Ok */0) {
    var image = path_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt: alt._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function download_app_mobile_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var button_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button_label"), null));
      if (button_label.TAG === /* Ok */0) {
        var button_href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button_href"), null));
        if (button_href.TAG === /* Ok */0) {
          var app_icon = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "app_icon"), null));
          if (app_icon.TAG === /* Ok */0) {
            var app_store_image = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "app_store_image"), null));
            if (app_store_image.TAG === /* Ok */0) {
              var google_play_store_image = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_play_store_image"), null));
              if (google_play_store_image.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          title: title._0,
                          sub_text: sub_text._0,
                          button_label: button_label._0,
                          button_href: button_href._0,
                          app_icon: app_icon._0,
                          app_store_image: app_store_image._0,
                          google_play_store_image: google_play_store_image._0
                        }
                      };
              }
              var e = google_play_store_image._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".google_play_store_image" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = app_store_image._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".app_store_image" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = app_icon._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".app_icon" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = button_href._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".button_href" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = button_label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".button_label" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function download_app_desktop_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_title"), null));
    if (sub_title.TAG === /* Ok */0) {
      var qr_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "qr_text"), null));
      if (qr_text.TAG === /* Ok */0) {
        var qr = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "qr"), null));
        if (qr.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    sub_title: sub_title._0,
                    qr_text: qr_text._0,
                    qr: qr._0
                  }
                };
        }
        var e = qr._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".qr" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = qr_text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".qr_text" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_title" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function section_download_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var download_app_mobile = download_app_mobile_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app_mobile"), null));
  if (download_app_mobile.TAG === /* Ok */0) {
    var download_app_desktop = download_app_desktop_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app_desktop"), null));
    if (download_app_desktop.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                download_app_mobile: download_app_mobile._0,
                download_app_desktop: download_app_desktop._0
              }
            };
    }
    var e = download_app_desktop._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".download_app_desktop" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = download_app_mobile._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".download_app_mobile" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function testimonial_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_name"), null));
  if (customer_name.TAG === /* Ok */0) {
    var city = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
    if (city.TAG === /* Ok */0) {
      var testimonial_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonial_text"), null));
      if (testimonial_text.TAG === /* Ok */0) {
        var rating = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rating"), null));
        if (rating.TAG === /* Ok */0) {
          var porter_service = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_service"), null));
          if (porter_service.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      customer_name: customer_name._0,
                      city: city._0,
                      testimonial_text: testimonial_text._0,
                      rating: rating._0,
                      porter_service: porter_service._0
                    }
                  };
          }
          var e = porter_service._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".porter_service" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = rating._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".rating" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = testimonial_text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".testimonial_text" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = city._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = customer_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_name" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function testimonials_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var testimonials = Decco.arrayFromJson(testimonial_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonials"), null));
    if (testimonials.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                testimonials: testimonials._0
              }
            };
    }
    var e = testimonials._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".testimonials" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function testimonials_section_wrapper_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var testimonials_section = testimonials_section_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "testimonials_section"), null));
  if (testimonials_section.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              testimonials_section: testimonials_section._0
            }
          };
  }
  var e = testimonials_section._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".testimonials_section" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function flat_faqs_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var faqs = Decco.arrayFromJson(SharedApiModel$PorterinFeature.faqs_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "faqs"), null));
      if (faqs.TAG === /* Ok */0) {
        var toggle_icon = MediaApiModel$PorterinFeature.image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "toggle_icon"), null));
        if (toggle_icon.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    sub_text: sub_text._0,
                    faqs: faqs._0,
                    toggle_icon: toggle_icon._0
                  }
                };
        }
        var e = toggle_icon._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".toggle_icon" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = faqs._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".faqs" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function pnm_section_faqs_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var data = Decco.optionFromJson(VehicleApiModelV2$PorterinFeature.section_faqs_attr_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
  if (data.TAG === /* Ok */0) {
    var faqs_section = Decco.optionFromJson(flat_faqs_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "faqs_section"), null));
    if (faqs_section.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                data: data._0,
                faqs_section: faqs_section._0
              }
            };
    }
    var e = faqs_section._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".faqs_section" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function city_image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var city_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_name"), null));
  if (city_name.TAG === /* Ok */0) {
    var city_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_label"), null));
    if (city_label.TAG === /* Ok */0) {
      var image = MediaApiModel$PorterinFeature.image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
      if (image.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  city_name: city_name._0,
                  city_label: city_label._0,
                  image: image._0
                }
              };
      }
      var e = image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = city_label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city_label" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = city_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".city_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function service_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var service_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_name"), null));
  if (service_name.TAG === /* Ok */0) {
    var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
    if (service_type.TAG === /* Ok */0) {
      var service_icon = MediaApiModel$PorterinFeature.image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_icon"), null));
      if (service_icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  service_name: service_name._0,
                  service_type: service_type._0,
                  service_icon: service_icon._0
                }
              };
      }
      var e = service_icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".service_icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = service_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_type" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = service_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".service_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function city_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = city_image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var services = Decco.arrayFromJson(service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
    if (services.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                image: image._0,
                services: services._0
              }
            };
    }
    var e = services._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".services" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function link_with_event_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
    if (link.TAG === /* Ok */0) {
      var section_event_action = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_event_action"), null));
      if (section_event_action.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  link: link._0,
                  section_event_action: section_event_action._0
                }
              };
      }
      var e = section_event_action._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".section_event_action" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = link._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".link" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function link_group_with_event_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var section_event_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_event_label"), null));
    if (section_event_label.TAG === /* Ok */0) {
      var links = Decco.arrayFromJson(link_with_event_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
      if (links.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  section_event_label: section_event_label._0,
                  links: links._0
                }
              };
      }
      var e = links._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".links" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = section_event_label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".section_event_label" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function section_internal_links_flat_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var link_section = Decco.arrayFromJson(link_group_with_event_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "link_section"), null));
    if (link_section.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                link_section: link_section._0
              }
            };
    }
    var e = link_section._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".link_section" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function banner_image_attrs_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var alternativeText = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alternativeText"), null));
    if (alternativeText.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  alternativeText: alternativeText._0,
                  name: name._0
                }
              };
      }
      var e = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = alternativeText._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".alternativeText" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function banner_image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var alt_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_text"), null));
  if (alt_text.TAG === /* Ok */0) {
    var image = Decco.optionFromJson(banner_image_attrs_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                alt_text: alt_text._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = alt_text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".alt_text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function section_banner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var banner_img = Decco.optionFromJson(banner_image_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img"), null));
  if (banner_img.TAG === /* Ok */0) {
    var banner_img_mobile = Decco.optionFromJson(banner_image_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img_mobile"), null));
    if (banner_img_mobile.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                banner_img: banner_img._0,
                banner_img_mobile: banner_img_mobile._0
              }
            };
    }
    var e = banner_img_mobile._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".banner_img_mobile" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = banner_img._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".banner_img" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var page_path = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page_path"), null));
  if (page_path.TAG === /* Ok */0) {
    var city_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_label"), null));
    if (city_label.TAG === /* Ok */0) {
      var show_house_field = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "show_house_field"), null));
      if (show_house_field.TAG === /* Ok */0) {
        var meta_data = Decco.optionFromJson(SharedApiModel$PorterinFeature.meta_json_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "meta_data"), null));
        if (meta_data.TAG === /* Ok */0) {
          var hero_section = Decco.optionFromJson(VehicleApiModelV2$PorterinFeature.hero_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hero_section"), null));
          if (hero_section.TAG === /* Ok */0) {
            var section_seo = Decco.optionFromJson(VehicleApiModelV2$PorterinFeature.section_seo_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_seo"), null));
            if (section_seo.TAG === /* Ok */0) {
              var section_banner = Decco.optionFromJson(section_banner_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_banner"), null));
              if (section_banner.TAG === /* Ok */0) {
                var section_download = Decco.optionFromJson(section_download_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_download"), null));
                if (section_download.TAG === /* Ok */0) {
                  var cities = Decco.arrayFromJson(city_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cities"), null));
                  if (cities.TAG === /* Ok */0) {
                    var section_faqs = Decco.optionFromJson(pnm_section_faqs_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_faqs"), null));
                    if (section_faqs.TAG === /* Ok */0) {
                      var section_addition_service = Decco.optionFromJson(addition_service_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_addition_service"), null));
                      if (section_addition_service.TAG === /* Ok */0) {
                        var section_pointers = Decco.optionFromJson(addition_service_section_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_pointers"), null));
                        if (section_pointers.TAG === /* Ok */0) {
                          var section_testimonials = Decco.optionFromJson(testimonials_section_wrapper_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_testimonials"), null));
                          if (section_testimonials.TAG === /* Ok */0) {
                            var section_internal_links = Decco.optionFromJson(section_internal_links_flat_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "section_internal_links"), null));
                            if (section_internal_links.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        page_path: page_path._0,
                                        city_label: city_label._0,
                                        show_house_field: show_house_field._0,
                                        meta_data: meta_data._0,
                                        hero_section: hero_section._0,
                                        section_seo: section_seo._0,
                                        section_banner: section_banner._0,
                                        section_download: section_download._0,
                                        cities: cities._0,
                                        section_faqs: section_faqs._0,
                                        section_addition_service: section_addition_service._0,
                                        section_pointers: section_pointers._0,
                                        section_testimonials: section_testimonials._0,
                                        section_internal_links: section_internal_links._0
                                      }
                                    };
                            }
                            var e = section_internal_links._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".section_internal_links" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = section_testimonials._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".section_testimonials" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = section_pointers._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".section_pointers" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = section_addition_service._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".section_addition_service" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = section_faqs._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".section_faqs" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = cities._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".cities" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = section_download._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".section_download" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = section_banner._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".section_banner" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = section_seo._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".section_seo" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = hero_section._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".hero_section" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = meta_data._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".meta_data" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = show_house_field._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".show_house_field" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = city_label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city_label" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = page_path._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".page_path" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

export {
  addition_service_pointer_decode ,
  addition_service_section_decode ,
  path_decode ,
  image_data_decode ,
  download_app_mobile_decode ,
  download_app_desktop_decode ,
  section_download_decode ,
  testimonial_decode ,
  testimonials_section_decode ,
  testimonials_section_wrapper_decode ,
  flat_faqs_section_decode ,
  pnm_section_faqs_decode ,
  city_image_decode ,
  service_decode ,
  city_decode ,
  link_with_event_decode ,
  link_group_with_event_decode ,
  section_internal_links_flat_decode ,
  banner_image_attrs_decode ,
  banner_image_decode ,
  section_banner_decode ,
  t_decode ,
}
/* No side effect */
